import { IContractBook, SupportedChainId } from "@eulerxyz/core-sdk"
import { ContractFunctionConfig } from "@eulerxyz/evc-sdk"
import { BaseTransactionFactory } from "./BaseTransactionFactory"
import {
  DeployPoolTransactionItem,
  TransactionItemUnion,
  TransactionItems,
  UninstallTransactionItem,
  isDeployPoolTransactionItem,
  isUninstallTransactionItem,
} from "./types"

export class EulerSwapTransactionFactory extends BaseTransactionFactory {
  customData: {
    [key: string]: any
  }

  constructor(chainId: SupportedChainId, contractBook: IContractBook) {
    super(chainId, contractBook)
    this.customData = {}
  }

  typeGuardConvertMultiple(
    _transactions: TransactionItems, // todo: modify this to use more specific type
  ): ContractFunctionConfig[] {
    const contractCallReadyTxs: ContractFunctionConfig[] = []
    for (const tx of _transactions) {
      const call = this.typeGuardConvertSingle(tx)
      contractCallReadyTxs.push(call)
    }
    return contractCallReadyTxs
  }

  typeGuardConvertSingle(
    _transaction: TransactionItemUnion, // todo: modify this to use more specific type
  ): ContractFunctionConfig {
    if (isDeployPoolTransactionItem(_transaction)) {
      return this.convertDeployPool(_transaction)
    }
    if (isUninstallTransactionItem(_transaction)) {
      return this.convertUninstall(_transaction)
    }
    throw this.errorUnsupportedTransactionType(_transaction)
  }
  convertUninstall(
    _transaction: UninstallTransactionItem,
  ): ContractFunctionConfig<
    typeof this.contractBook.eulerSwapFactory.abi,
    "uninstallPool"
  > {
    const eulerSwapFactoryAddress =
      this.contractBook.eulerSwapFactory.address[this.chainId]
    if (!eulerSwapFactoryAddress) {
      throw new Error("[EulerSwapFactory] address not found")
    }
    return {
      abi: this.contractBook.eulerSwapFactory.abi,
      functionName: "uninstallPool",
      value: 0n,
      address: eulerSwapFactoryAddress,
      onBehalfOfAccount: _transaction.account,
    }
  }

  convertDeployPool(
    _transaction: DeployPoolTransactionItem,
  ): ContractFunctionConfig<
    typeof this.contractBook.eulerSwapFactory.abi,
    "deployPool"
  > {
    const eulerSwapFactoryAddress =
      this.contractBook.eulerSwapFactory.address[this.chainId]
    if (!eulerSwapFactoryAddress) {
      throw new Error("[EulerSwapFactory] address not found")
    }

    // TODO: Pending
    return {
      abi: this.contractBook.eulerSwapFactory.abi,
      functionName: "deployPool",
      value: 0n,
      address: eulerSwapFactoryAddress,
      onBehalfOfAccount: _transaction.account,
      args: [
        {
          vault0: _transaction.vault0,
          vault1: _transaction.vault1,
          eulerAccount: _transaction.account,
          equilibriumReserve0: _transaction.equilibriumReserve0,
          equilibriumReserve1: _transaction.equilibriumReserve1,
          priceX: _transaction.priceX,
          priceY: _transaction.priceY,
          concentrationX: _transaction.concentrationX,
          concentrationY: _transaction.concentrationY,
          fee: _transaction.fee,
          protocolFee: _transaction.protocolFee,
          protocolFeeRecipient: _transaction.protocolFeeRecipient,
        } as const,
        {
          currReserve0: _transaction.currReserve0,
          currReserve1: _transaction.currReserve1,
        } as const,
        _transaction.salt as `0x${string}`,
      ],
    }
  }
}
